<template>
    <v-container flat style="max-width: 1000px">
        <v-window v-model="step" touchless>
            <v-window-item :value="0">
                <UploadDocuments
                    :showFirstPrevious="false"
                    :documentType="documentType"
                    :inExtensions="['csv', 'tsv', 'txt', 'xlsx', 'xls']"
                    :multiple="false"
                    :freeTag="false"
                    :gDrive="true"
                    @fileInput="onFileChanged"
                    @fileDeleted="onFileDeleted"
                    @testFileInput="onTestFileChanged"
                />
            </v-window-item>
            <v-window-item :value="1">
                <ColumnCorrespondence
                    ref="columnComponent"
                    v-if="step > 0 && existingFile"
                    :result="result"
                    :extension="extension"
                    :actions="actions"
                    :ruleManager="ruleManager"
                    :formatColumns="formatColumns"
                    :requireDateVerification="true"
                    :updateAccountingDates="true"
                    @columns-chosen="onChosenColumns($event)"
                    @back="step = 0"
                />
            </v-window-item>
            <v-window-item :value="2">
                <div v-if="importedItems.length">
                    <v-row no-gutters v-if="missingVatTypes" class="justify-end align-center mx-5">
                        Type de tva général:
                        <v-col cols="3" class="pl-2">
                            <v-select-filled
                                hide-details
                                density="compact"
                                :items="vatTypes"
                                v-model="generalVatType"
                                item-title="text"
                                item-value="value"
                            />
                        </v-col>
                        <v-col cols="1" class="pl-2">
                            <v-btn
                                class="btn"
                                color="primary"
                                rounded
                                dark
                                size="small"
                                @click="setAllVatTypes(generalVatType)"
                            >
                                Appliquer
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-data-table
                        :headers="importedHeaders"
                        :items="importedItems"
                        class="table"
                        density="compact"
                        fixed-header
                        :loading="verifLoading"
                    >
                        <template v-slot:item="{ item, index }">
                            <tr :style="'background-color:' + item.colorAlert">
                                <td
                                    v-if="item.customer === 'NOTIN'"
                                    class="text-center"
                                    :style="'pointer-events: none'"
                                >
                                    <v-badge
                                        color="primary"
                                        content="New"
                                        location="top end"
                                        floating
                                    >
                                        {{ item.company }}
                                    </v-badge>
                                </td>
                                <td v-else :style="'pointer-events: none'" class="text-center">
                                    {{ item.company }}
                                </td>

                                <td :style="'pointer-events: none'" class="text-center">
                                    {{ getSiretValue(item.siret) }}
                                </td>
                                <!-- <td class="text-center"> {{ item.grossAmount }} </td> -->
                                <td :style="'pointer-events: none'" class="text-center">
                                    {{ convertAmount(item.netAmount) }} &#x20ac;
                                </td>
                                <td width="200px" v-if="item.vatRate === 0" class="align-center">
                                    <v-select-filled
                                        hide-details
                                        density="compact"
                                        v-model="item.vatType"
                                        :items="vatTypes"
                                        item-title="text"
                                        item-value="value"
                                        class="py-1"
                                    />
                                </td>
                                <td v-else :style="'pointer-events: none'" class="text-center">
                                    {{ item.vatRate1 ? "MultiTVA" : item.vatRate }}
                                </td>
                                <!-- <td class="text-center"> {{ item.vatAmount }} </td> -->
                                <td :style="'pointer-events: none'" class="text-center">
                                    {{ convertDate(item.date) }}
                                </td>
                                <td :style="'pointer-events: none'" class="text-center">
                                    {{ item.dueDate ? convertDate(item.dueDate) : "" }}
                                </td>
                                <td
                                    :style="'pointer-events: none'"
                                    class="text-center"
                                    v-if="importedAccountingDates.length"
                                >
                                    {{
                                        item.accountingDate ? convertDate(item.accountingDate) : ""
                                    }}
                                </td>
                                <td :style="'pointer-events: none'" class="text-center">
                                    {{ item.invoiceNumber }}
                                </td>
                                <td :style="'pointer-events: none'" class="text-center">
                                    {{ item.netAmount }}
                                </td>
                                <td
                                    v-if="item.status === 'FULL_INVOICE_IN_DB'"
                                    class="text-center"
                                    :style="'pointer-events: none'"
                                >
                                    La facture existe déjà
                                </td>
                                <td
                                    v-else-if="item.status === 'NO_AVLB_VAT'"
                                    class="text-center"
                                    :style="'pointer-events: none'"
                                >
                                    La TVA à {{ item.vatRate }} n'existe pas
                                </td>
                                <td
                                    v-else-if="item.status === 'NO_VAT_TYPE'"
                                    class="text-center"
                                    :style="'pointer-events: none'"
                                >
                                    <v-icon v-if="item.vatType" icon="$fa-check" color="green" />
                                    <span v-else>Le type de TVA n'existe pas</span>
                                </td>
                                <td
                                    v-else-if="item.status === 'PARTIAL_INVOICE_IN_DB'"
                                    class="text-center"
                                    :style="'pointer-events: none'"
                                >
                                    La facture existe déjà, mais certaines informations ne
                                    correspondent pas
                                </td>
                                <td
                                    v-else-if="item.status === 'SIRET_WRONG'"
                                    class="text-center"
                                    :style="'pointer-events: none'"
                                >
                                    Le numero de SIRET n'est pas correct
                                </td>
                                <td
                                    v-else-if="item.status === 'GOOD_INVOICE'"
                                    class="text-center"
                                    :style="'pointer-events: none'"
                                >
                                    <v-icon icon="$fa-check" color="green" />
                                </td>
                                <td v-else :style="'pointer-events: none'">
                                    <v-progress-circular indeterminate color="primary" />
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </div>
            </v-window-item>
        </v-window>
    </v-container>
</template>

<script lang="ts">
import { Component, Prop, Watch, toNative, Ref } from "vue-facing-decorator";

import ColumnCorrespondence from "./ColumnCorrespondence.vue";
import { ImportDocumentBase } from "./ImportDocumentBase";
import OssDataTable from "../ossComponents/ossDataTable2.vue";

import { DialogAction } from "../../services/dialogAction";

import SALES_INVOICE_VERIF from "../../graphql/SalesInvoices.gql";
import SALES_INVOICES_IMPORT from "../../graphql/SalesInvoicesImport.gql";
import UploadDocuments from "../document/UploadDocuments.vue";

@Component({
    components: {
        UploadDocuments,
        ColumnCorrespondence,
        OssDataTable,
    },
    emits: ["documentImported", "width"],
})
export class SalesInvoiceImport extends ImportDocumentBase {
    @Prop({ default: null }) actions: { action: DialogAction } | null;
    @Prop({ default: "" }) selectedCompanyId: string;

    @Ref("columnComponent") columnComponent;

    step = 0;

    vatTypes = [
        { text: "Aucun", value: "NO_VAT_TYPE" },
        { text: "Intracom", value: "INTRACOM" }, // not vat accountable account (invoice)
        { text: "Export", value: "EXPORT" },
        { text: "Autoliquidation", value: "REVERSE_CHARGE" },
    ];

    generalVatType = "";

    get missingVatTypes() {
        if (this.importedItems.some((i) => i.vatRate === 0)) {
            return true;
        }
        return false;
    }

    async setAllVatTypes(e) {
        this.importedItems.forEach((item) => {
            if ((!item.vatType || item.vatTypeChanged) && item.vatRate === 0) {
                item.vatType = e;
                item.vatTypeChanged = true;
            }
        });
    }

    beforeMount() {
        this.actions.action.loading = this.importLoading;
        this.setActionsButton();
    }

    resultInvoice(grossAmount, netAmount, vatRate, vatAmount) {
        if (
            vatRate === null &&
            ((netAmount === null && grossAmount === null) ||
                (vatAmount === null && grossAmount === null) ||
                (netAmount === null && vatAmount === null))
        ) {
            vatRate = 0;
        }
        let vatRateResult = vatRate;
        let netAmountResult = netAmount;
        let vatAmountResult = vatAmount;
        let grossAmountResult = grossAmount;
        if (grossAmount !== null && netAmount !== null && vatRate !== null && vatAmount !== null) {
            console.log("invoice item data complete");
        } else if (vatRate !== null) {
            if (grossAmount !== null) {
                netAmountResult = grossAmount / (1 + vatRate / 100);
                vatAmountResult = grossAmount - netAmountResult;
            } else if (netAmount !== null) {
                grossAmountResult = netAmount * (1 + vatRate / 100);
                vatAmountResult = grossAmountResult - netAmount;
            } else if (vatAmount !== null) {
                grossAmountResult = (vatAmount * (1 + vatRate / 100)) / vatRate;
                netAmountResult = grossAmountResult - vatAmount;
            }
        } else if (grossAmount !== null) {
            if (netAmount !== null) {
                vatAmountResult = grossAmount - netAmount;
                vatRateResult = (vatAmount / netAmount) * 100;
            } else if (vatAmount !== null) {
                netAmountResult = grossAmount - vatAmount;
                vatRateResult = (grossAmount / netAmountResult - 1) * 100;
            }
        } else if (netAmount !== null) {
            if (vatAmount !== null) {
                grossAmountResult = netAmount + vatAmount;
                vatRateResult = (vatAmount / netAmount) * 100;
            }
        }

        return {
            grossAmount: grossAmountResult,
            netAmount: netAmountResult,
            vatRate: Math.round(vatRateResult),
            vatAmount: vatAmountResult,
        };
    }

    formatSalesInvoices() {
        this.importedItems.map((x) => {
            const invoicesPrices = this.resultInvoice(
                x.grossAmount ? parseFloat(x.grossAmount) : null,
                x.netAmount ? parseFloat(x.netAmount) : null,
                x.vatRate ? parseFloat(x.vatRate) : null,
                x.vatAmount ? parseFloat(x.vatAmount) : null,
            );
            x.grossAmount = invoicesPrices.grossAmount;
            x.netAmount = invoicesPrices.netAmount;
            x.vatAmount = invoicesPrices.vatAmount;
            x.vatRate = invoicesPrices.vatRate;
            return x;
        });
    }

    async verifySalesInvoices() {
        this.verifLoading = true;
        let result = [];
        if (this.selectedCompanyId && this.importedItems?.length) {
            const query = await this.$apollo.query({
                query: SALES_INVOICE_VERIF,
                variables: {
                    salesInvoices: this.importedItems,
                    idCompany: this.selectedCompanyId,
                },
            });
            result = query.data.salesInvoices.salesInvoices || [];
        }

        if (result.length) {
            this.importedItems = JSON.parse(JSON.stringify(result));
        }
        return result;
    }

    async onChosenColumns(data) {
        const { importedItems, importedHeaders, importedAccountingDates } = data;

        this.importedItems = importedItems;
        this.importedHeaders = importedHeaders;
        this.importedAccountingDates = importedAccountingDates;

        this.formatSalesInvoices();

        const result = await this.verifySalesInvoices();

        if (result.length) {
            this.verifLoading = false;
            this.step++;
        }
    }

    async valid() {
        this.importLoading = true;
        if (this.selectedCompanyId && this.importedItems.length) {
            const result = await this.$apollo.mutate({
                mutation: SALES_INVOICES_IMPORT,
                variables: {
                    salesInvoices: this.importedItems,
                    idCompany: this.selectedCompanyId,
                },
            });
            if (result?.data?.salesInvoicesImport) {
                this.importLoading = false;
                this.$emit("documentImported");
            }
        }
    }

    importDisabled() {
        if (!this.importedItems.length) {
            return true;
        }
        if (this.importedItems.findIndex((i) => i.vatType === "") > -1) {
            return true;
        }
        return false;
    }

    @Watch("step")
    setActionsButton() {
        if (this.actions && this.actions.action) {
            if (this.step === 0) {
                this.actions.action.display = true;
                this.actions.action.title = "Suivant";
                this.actions.action.disabled = () => {
                    return !this.existingFile;
                };
                this.actions.action.function = () => {
                    this.step++;
                };
            } else if (this.step === 1) {
                this.actions.action.display = true;
                this.actions.action.title = "Suivant";
                if (this.columnComponent) {
                    this.columnComponent.setActionButton();
                }
                this.actions.action.loading = () => {
                    return this.verifLoading;
                };
            } else if (this.step === 2) {
                this.actions.action.display = true;
                this.actions.action.title = "Importer";
                this.actions.action.disabled = () => {
                    return this.importDisabled();
                };
                this.actions.action.function = async () => {
                    await this.valid();
                };
                this.actions.action.previous = () => {
                    this.step--;
                };
                this.actions.action.loading = () => {
                    return this.importLoading;
                };
            }
        }
        this.$emit("width");
    }
}

export default toNative(SalesInvoiceImport);
</script>
